export default __webpack_public_path__ + "static/media/add-tag-listing-gold.b283e307.svg";